<pages-container
  [title]="title()"
  [icon]="'today'"
  [showSearch]="false">
  <div back-button>
    <button class="back-button" mat-icon-button (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
  <div buttons>
    <button mat-raised-button
            class="mat-white-bg"
            (click)="openDocumentation()">
      <span>{{ 'event.documentation' | translate }}</span>
    </button>
    @if (eventData?.goToChat) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="openChat()">
        <span>{{ 'event.openChat' | translate }}</span>
      </button>
    }
    @if(!id() && !copyId()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="saveEvent()" [disabled]="!isValid()">
        <span>{{ 'main.add' | translate }}</span>
      </button>
    }

    @if (!eventData?.reservationPossible && eventData?.editButton && type() === 'edit' &&
    !deleted()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="openDialog()">
        <span>{{ 'main.generateFreeCode' | translate }}</span>
      </button>
    }
    @if (eventData?.unSubscribeButon &&
    eventData?.enrolment && (reserve || eventData.numberOfPlace) && type() === 'edit' && !deleted()) {
      <button mat-raised-button
              class="save-product-button mat-white-bg mt-16 mt-sm-0"
              (click)="openDialogReserve()">
        <span>{{ 'main.reservePlace' | translate }}</span>
      </button>
    }
    @if (eventData?.recommendButton && type() === 'edit' &&
    !deleted() && !eventData?.recommendationCreated) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="createRecommendation()">
        <span>{{ 'event.recommend' | translate }}</span>
      </button>
    }
    @if (eventData?.recommendButton && type() === 'edit' &&
    !deleted() && eventData?.recommendationCreated && eventData?.canRemoveRecommendation) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="removeRecommendation()">
        <span>{{ 'event.remove_recommendation' | translate }}</span>
      </button>
    }
    <span matTooltip="{{'event.recommendation_created' | translate}}">
          @if (eventData?.recommendButton && type() === 'edit' &&
          !deleted() && eventData?.recommendationCreated && !eventData?.canRemoveRecommendation) {
            <button mat-raised-button
                    class="mat-white-bg"
                    disabled>
              <span>{{ 'event.recommend' | translate }}</span>
            </button>
          }
        </span>
    @if (editing() && eventData?.editButton && (type() !== '') && !deleted()) {
      <span [matTooltip]="getAddEventError" [matTooltipDisabled]="!getAddEventError">
            <button mat-raised-button
                    class="mat-white-bg"
                    (click)="saveEvent()" [disabled]="!isValid()">
              <span>{{ (type() === 'copy' ? 'main.add' : 'main.update') | translate }}</span>
            </button>
          </span>
    }
    @if (editing() && eventData?.editButton && type() === 'edit' && !deleted()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="deleteEvent()">
        <span>{{ 'main.delete' | translate }}</span>
      </button>
    }
    @if (editing() && eventData?.editButton && type() === 'edit' && !deleted()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="cancelEditing()">
        <span>{{ 'main.cancel' | translate }}</span>
      </button>
    }
    @if (!editing() && eventData?.editButton && type() === 'edit' && !deleted()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="startEditing()">
        <span>{{ 'main.edit' | translate }}</span>
      </button>
    }
    @if (eventData?.subscribeButon && type() === 'edit' && !deleted()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="subscriptionToEvent()">
        <span>{{ 'main.subscription' | translate }}</span>
      </button>
    }
    @if (eventData?.unSubscribeButon && type() === 'edit' && !deleted()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="unSubscriptionToEvent()">
        <span>{{ 'main.unSubscription' | translate }}</span>
      </button>
    }
    @if (deleted()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="reactivateEvent()">
        <span>{{ 'main.reactivate' | translate }}</span>
      </button>
    }
<!--    @if (eventData?.unSubscribeButon &&-->
<!--    eventData?.enrolment && (eventData?.reserve || eventData.numberOfPlace) && type() === 'edit' && !deleted()) {-->
<!--      <button mat-raised-button-->
<!--              class="save-product-button mat-white-bg mt-16 mt-sm-0"-->
<!--              (click)="openDialogReserve()">-->
<!--        <span>{{ 'main.reservePlace' | translate }}</span>-->
<!--      </button>-->
<!--    }-->
  </div>
  <div main-content class="event-detail-page">
    <mat-tab-group>
      <mat-tab>
        <ng-template matTabLabel>{{ 'event.mainInfo' | translate }}</ng-template>
        @if (editing() || (!id() && !copyId())) {
          <event-form [eventData]="eventData" (formResult)="getForm($event)"
                      (isValid)="isValid.set($event)" (isChangedOutput)="isChanged.set($event)"></event-form>
        }
        @if (!editing() && id() && eventData) {
          <event-detail-info [eventData]="eventData"
                             (addChatAdmins)="addChatAdmins()"
                             (participantsLength)="eventData.participants = $event"></event-detail-info>
        }
        @if (type() === 'edit' && eventData?.editButton) {
          <mat-tab label="{{'event.estimation_tab_info' | translate}}">
            <div class="content-card mat-white-bg">
              <estimation-component [eventData]="eventData"
                              [country]="'CH'"
                              [organization]="eventData?.organizationId"
                              [participantNumber]="0"
                              [participantFriendCount]="0"
                              [cost]="eventData?.cost"
                              [costFriend]="eventData?.costFriend"></estimation-component>
            </div>
          </mat-tab>
          <mat-tab label="{{'main.subscriptionBy' | translate}}">
            <div class="content-card mat-white-bg">
              <subscriber-component [eventData]="eventData"></subscriber-component>
            </div>
          </mat-tab>
        }
      </mat-tab>
    </mat-tab-group>

  </div>
</pages-container>
